import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ViewMode } from '@veritas-shared/models/view-mode';

@Injectable({
  providedIn: 'root'
})
export class EditFormService {
  constructor (
    protected fb: FormBuilder,
  ) {}

  public getForm = (viewMode: ViewMode): FormGroup => this.fb.group({
    id: [''],
    code: [
      { value: '', disabled: viewMode !== ViewMode.New },
      Validators.required,
    ],
    binId: [{ value: '', disabled: viewMode === ViewMode.View }],
    regionCode: [{ value: '', disabled: true }, Validators.required],
    regionCodeSecond: [{ value: '', disabled: true }],
    regionCodeThird: [{ value: '', disabled: true }],
    supplierName: [{ value: '', disabled: true }, Validators.required],
    binType: [{ value: '', disabled: true }],
    garbageType: [{ value: '', disabled: true }],
    location: [
      { value: '', disabled: viewMode === ViewMode.View },
      Validators.required,
    ],
    collectionPointId: [
      { value: undefined, disabled: viewMode === ViewMode.View },
    ],
    collectionPointName: [
      { value: '', disabled: viewMode === ViewMode.View },
    ],
    collectionPointDistance: [
      { value: 30, disabled: viewMode === ViewMode.View },
    ],
    address: [{ value: '', disabled: true }, Validators.required],
    userType: [{ value: undefined, disabled: true }],
    imei: [{ value: '', disabled: true }],
    tag: [{ value: '', disabled: true }],
  })
}
